<!-- begin::Scrolltop -->

	<div ktScrollTop [options]="scrollTopOptions" id="kt_scrolltop" class="kt-scrolltop">
		<i class="la la-arrow-up"></i>
	</div>
	<div  id="kt-scrolltoptype"  class="kt-scrolltoptype" (click)=notify()>
		<!-- <button>ddddd</button> -->

	</div>
<!-- end::Scrolltop -->